import { getUserDiagnoticsTagColor } from 'utilities/SystemUtils';
import AppChip from './AppChip';
import { UserDiagnosticsTag } from 'types/models/UserDiagnosticsModel';

export const AppUserDiagnosticsTagChip = ({ userDiagnosticsTag }: {userDiagnosticsTag: UserDiagnosticsTag}) => {
  const displayValue = UserDiagnosticsTag[userDiagnosticsTag];

  return (
    <AppChip
      value={userDiagnosticsTag}
      getColor={getUserDiagnoticsTagColor}
      displayValue={displayValue}
    />
  );
};

export default AppUserDiagnosticsTagChip;
